"use strict";
// schemas.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisualizationCreatePayloadSchema = exports.VisualizationObjectSchema = void 0;
const zod_1 = require("zod");
const axis_1 = require("../axis");
const environment_1 = require("../environment");
const label_1 = require("../label");
const metric_1 = require("../metric");
const query_1 = require("../query");
const series_1 = require("../series");
const table_1 = require("../table");
exports.VisualizationObjectSchema = zod_1.z.object({
    title: zod_1.z.string().optional(),
    axes: zod_1.z.array(axis_1.AxisSchema),
    labels: zod_1.z.array(label_1.AnyLabelSchema),
    series: zod_1.z.array(series_1.SeriesSchema),
});
exports.VisualizationCreatePayloadSchema = zod_1.z.object({
    kind: zod_1.z.enum(['trend', 'category']),
    metrics: zod_1.z.array(metric_1.AnyMetricSchema),
    query: query_1.CreateVisualizationQuerySchema,
    environment: environment_1.EnvironmentSchema.optional(),
    tables: zod_1.z.array(table_1.TableSchema).optional(),
});
//# sourceMappingURL=visualizationSchema.js.map